<template>
	<div>
		<el-form>
			<el-form-item label="落地页:" style="width: 40%;text-align: left;">
				<el-button type="primary" size="small" style="width: 5rem;" @click="addPageAction">新建</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" max-height="500" border style="width: 90%">
			<el-table-column prop="name" label="落地页名称" width="180">
			</el-table-column>
			<el-table-column prop="title" label="标题" width="180">
			</el-table-column>
			<el-table-column prop="hospitalName" label="医院名称">
			</el-table-column>
			<el-table-column prop="hospitalTel" label="医院电话">
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="300">
				<template slot-scope="scope">
					<!-- <el-button type="text" size="small">查看</el-button> -->
					<el-button type="text" size="small" @click="handleClick(scope.row)">编辑</el-button>
					<el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
					<el-button v-if="scope.row.url == 0" type="text" size="small" @click="createProj(scope.row)">一键生成</el-button>
					<el-button v-else type="text" size="small"
					@click='showLinks(scope.row)'>查看链接</el-button>
					
				</template>
			</el-table-column>
		</el-table>
		
		<div style="margin-top: 2.5rem">
			<el-button style="width: 6.25rem;height: 2.8125rem;" @click="back()">取消</el-button>
		</div>
		
		
		<el-dialog 
		:visible.sync="visible"
		width="60%"
		title="链接"
		:close-on-click-modal="false"	
		:close-on-press-escape="false"
		center
		@close="closeLinks"
		>
			<div class="links">
				<!-- <div class="link"><span>落地页地址：</span><span>1111111</span><el-button type="text" size="small" style="margin-left: 2%;">复制链接</el-button></div>
				<div class="link"><span>引入脚本：</span><span>222222</span><el-button type="text" size="small" style="margin-left: 2%;">复制链接</el-button></div> -->
				<div class="link" v-for="(item, index) in links">
					<div class="link_label">{{item.label+"："}}</div>
					<el-input v-model="item.url" disabled ></el-input>
					<el-button type="text" size="small" style="margin-left: 2%;"
					v-clipboard:error="onError"
					v-clipboard:copy="item.url" v-clipboard:success="onCopy"
					>复制链接</el-button>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
			    <el-button @click="closeLinks" size="mini" type="primary">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// import Clipboard from 'clipboard';
	
	export default {
		name:'pagelist',
		
		props:['projectInfo'],
		
		data() {
			return {
				tableData: [],
				nowProject: this.projectInfo,
				configUrl: '',
				visible:false,
				links:[]
			}
		},
		
		created() {
			console.log('pagelist created nowProject = ', this.nowProject)
			this.pageListRequest()
		},
		
		methods:{
			back() {
				console.log('pagelist back action')
				this.$emit('pageBack')
			},
			
			addPageAction() {
				console.log('pagelist addPageAction')
				this.$emit('listaddpage')
			},
			
			async pageListRequest() {
				console.log('pagelist pageListRequest')
				var api = "/projectchat/landingPage/list/"+this.nowProject.id;
				const response = await this.util.postRequest({
					url: api,
					method: "GET"
				});
				console.log("pagelist pageListRequest response = ", response);
				if (response.resultCode === '10000') {
					this.tableData = response.data
				} else {
					this.$message.error(response.desc)
				}
			},
			
			handleClick(item) {
				console.log('pagelist handleClick item = ', item)
				this.$emit('listeditpage', item)
			},
			
			handleDelete(item) {
				console.log('pagelist handleDelete item = ', item)
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deletePage(item)
					
				}).catch(() => {
					
				});
				
			},
			
			async deletePage(item) {
				console.log('pagelist deletePage id = ', this.nowProject.id)
				console.log('pagelist deletePage pageId = ', item.pageId)
				var api = "/projectchat/landingPage/delete";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id:this.nowProject.id,
						pageId: item.pageId
					}
				});
				console.log("pagelist deletePage response = ", response);
				if (response.resultCode === '10000') {
					this.pageListRequest()
				} else {
					this.$message.error(response.desc)
				}
			},
			
			async createProj(item) {
				console.log('pagelist createProj item = ', item)
				console.log('pagelist createProj proj = ', this.nowProject)
				var api = "/projectchat/landingPage/configProduce";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						id:this.nowProject.id,
						pageId: item.pageId
					}
				});
				console.log("pagelist createProj response = ", response);
				const loading = this.$loading({
					  lock: true,
					  text: '生成中',
					  spinner: 'el-icon-loading',
					  background: 'rgba(0, 0, 0, 0.7)'
				})
				setTimeout(() => {
				    loading.close();
					if (response.resultCode === '10000') {
						console.log("pagelist createProj url = ", response.data.url);
						item.url = response.data.url
					} else {
						this.$message.error(response.desc)
					}
				}, 5000)
				
			},
			
			// 复制成功
			onCopy(e){
				this.$message({
					message:'复制成功！',
					type:'success'
				})
			},
			
			// 复制失败
			onError(e){
				this.$message({
					message:'复制失败！',
					type:'error'
				})
			},
			// 展示链接
			showLinks(row){
				let url = 
				this.links.push({
					url:row.url,
					label:"落地页地址",
				})
				this.links.push({
					url:'\<script src=\"' + row.jsUrl + '\"><\/script>',
					label:"引入脚本",
				})
				this.visible = true
			},
			
			closeLinks(){
				this.visible = false
				this.links = []
			}
		}
	}
</script>

<style>
	.link{
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		margin-top: 2%;
	}
	
	.link_label{
		white-space: nowrap;
		width: 15%;
		text-align: right;
	}
</style>
